import SupportPageContainer from './support-page-container'

export default SupportPageContainer
